import { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import {
	AnonymousStudentProfileUpdated,
	AnonymousStudentServiceReady,
	AnonymousStudentProfileSynced,
	IAnonymousStudentService,
	StudentRepositoryStateType
} from '@studyportals/anonymous-student-interfaces';
import { IStudent, StudentField } from '@studyportals/studentdomain';

/* eslint-disable @typescript-eslint/no-non-null-assertion */
class FooterLocalizationButton
	implements
		ISubscriber<AnonymousStudentServiceReady | AnonymousStudentProfileUpdated | AnonymousStudentProfileSynced>
{
	private anonymousStudent?: IAnonymousStudentService;

	constructor() {
		if (window.EventAggregationService) {
			window.EventAggregationService.subscribeTo(AnonymousStudentServiceReady.EventType, this, true);
			window.EventAggregationService.subscribeTo(AnonymousStudentProfileUpdated.EventType, this, false);
			window.EventAggregationService.subscribeTo(AnonymousStudentProfileSynced.EventType, this, false);
		}
	}

	public async notify(
		event: AnonymousStudentServiceReady | AnonymousStudentProfileUpdated | AnonymousStudentProfileSynced
	): Promise<void> {
		if (event.eventType === AnonymousStudentServiceReady.EventType) {
			await this.handleAnonymousStudentReadyEvent(event as AnonymousStudentServiceReady);
		}

		if (event.eventType === AnonymousStudentProfileUpdated.EventType) {
			await this.handleAnonymousStudentProfileUpdatedEvent(event as AnonymousStudentProfileUpdated);
		}

		if (event.eventType === AnonymousStudentProfileSynced.EventType) {
			await this.handleAnonymousStudentProfileSyncedEvent(event as AnonymousStudentProfileSynced);
		}
	}

	private async handleAnonymousStudentReadyEvent(event: AnonymousStudentServiceReady): Promise<void> {
		this.anonymousStudent = event.anonymousStudentService;
		await this.updateButton();
	}

	private async handleAnonymousStudentProfileUpdatedEvent(event: AnonymousStudentProfileUpdated): Promise<void> {
		const changes = event.changes;
		if (
			changes[StudentField.NATIONALITY_COUNTRY_ID] ||
			changes[StudentField.NATIONALITY_COUNTRY_ISO] ||
			changes[StudentField.CURRENCY]
		) {
			await this.updateButton();
		}
	}

	private async handleAnonymousStudentProfileSyncedEvent(event: AnonymousStudentProfileSynced): Promise<void> {
		if (event.state === StudentRepositoryStateType.ONLINE) {
			await this.updateButton();
		}
	}

	private async updateButton(): Promise<void> {
		const data = await this.anonymousStudent!.getStudentData([
			StudentField.NATIONALITY_COUNTRY_ISO,
			StudentField.CURRENCY
		]);

		this.updateNationalityOnButtons(data);
		this.updateCurrencyOnButtons(data);
	}

	private updateNationalityOnButtons(data: IStudent): void {
		if (data[StudentField.NATIONALITY_COUNTRY_ISO] === undefined) {
			return;
		}

		const locationButtons = document.getElementsByClassName('js-locationText');
		for (const locationButton of locationButtons) {
			locationButton.textContent = data[StudentField.NATIONALITY_COUNTRY_ISO]!.toUpperCase();
		}
	}

	private updateCurrencyOnButtons(data: IStudent): void {
		if (data[StudentField.CURRENCY] === undefined) {
			return;
		}

		const currencyButtons = document.getElementsByClassName('js-currencyText');
		for (const currencyButton of currencyButtons) {
			currencyButton.textContent = data[StudentField.CURRENCY]!.toUpperCase();
		}
	}
}

new FooterLocalizationButton();
